import { eventHasRun } from '../../utils/eventTracker';
import getLinkText from '../../utils/getLinkText';

export const DDC_LINK_RECOMMENDEDVEHICLE = 'ddc.link.recommendedVehicle';

function recommendedVehicle(win, { timeStamp, element }) {
	const {
		DDC: {
			dataLayer: {
				page: {
					pageInfo: { pageName }
				}
			}
		}
	} = win;
	let eventObject;
	if (
		!eventHasRun(DDC_LINK_RECOMMENDEDVEHICLE, {
			timeStamp
		})
	) {
		eventObject = {
			eventType: DDC_LINK_RECOMMENDEDVEHICLE,
			eventData: {
				text: getLinkText(element, win) || '',
				url: element.getAttribute('data-vdp-href') || '',
				pageName,
				element
			}
		};
	}

	return eventObject;
}

export default recommendedVehicle;
